import React, { useEffect, useState } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [shouldSlide, setShouldSlide] = useState(false);

  useEffect(() => {
    const slideTimer = setTimeout(() => {
      setShouldSlide(true);
    }, 5000);

    const completeTimer = setTimeout(() => {
      onComplete();
    }, 6000);

    return () => {
      clearTimeout(slideTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-[9999] transition-transform duration-1000 ease-in-out ${
        shouldSlide ? '-translate-y-full' : 'translate-y-0'
      }`}
      style={{
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
      }}
    >
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 20px',
        }}
      >
        {/* Para motoristas */}
        <p
          style={{
            fontSize: '13px',
            color: '#999',
            marginBottom: '8px',
            letterSpacing: '0.5px',
          }}
        >
          Para motoristas
        </p>

        {/* Uber / 99 badges */}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
          <span
            style={{
              background: '#fff',
              color: '#000',
              fontSize: '13px',
              fontWeight: 700,
              padding: '6px 16px',
              borderRadius: '6px',
              letterSpacing: '0.5px',
            }}
          >
            Uber
          </span>
          <span
            style={{
              background: '#f5c518',
              color: '#000',
              fontSize: '13px',
              fontWeight: 700,
              padding: '6px 16px',
              borderRadius: '6px',
              letterSpacing: '0.5px',
            }}
          >
            99
          </span>
        </div>

        {/* Oferta Especial badge */}
        <div
          style={{
            background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
            color: '#000',
            fontSize: '14px',
            fontWeight: 700,
            padding: '8px 20px',
            borderRadius: '999px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          ⭐ Oferta Especial
        </div>

        {/* Plano Mensal title */}
        <h2
          style={{
            fontSize: '28px',
            fontWeight: 700,
            color: '#fff',
            textAlign: 'center',
            margin: '0 0 8px 0',
          }}
        >
          Plano Mensal
        </h2>

        {/* Subtitle */}
        <p
          style={{
            fontSize: '18px',
            fontWeight: 600,
            color: '#e5e5e5',
            textAlign: 'center',
            margin: '0 0 20px 0',
            lineHeight: 1.4,
          }}
        >
          75 minutos por mês para usar como quiser!
        </p>

        {/* Pricing card */}
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '20px',
            padding: '24px 20px',
            textAlign: 'center',
            marginBottom: '18px',
            width: '100%',
            maxWidth: '320px',
            backdropFilter: 'blur(10px)',
          }}
        >
          {/* Old price with discount */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              marginBottom: '12px',
            }}
          >
            <span
              style={{
                fontSize: '16px',
                color: '#999',
                textDecoration: 'line-through',
              }}
            >
              R$ 75,00
            </span>
            <span
              style={{
                background: '#ef4444',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 700,
                padding: '4px 10px',
                borderRadius: '6px',
              }}
            >
              -33%
            </span>
          </div>

          {/* New price */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '2px',
              marginBottom: '12px',
            }}
          >
            <span style={{ fontSize: '20px', fontWeight: 600, color: '#fff', marginTop: '12px' }}>
              R$
            </span>
            <span style={{ fontSize: '64px', fontWeight: 800, color: '#fff', lineHeight: 1 }}>
              49
            </span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '12px' }}>
              <span style={{ fontSize: '20px', fontWeight: 600, color: '#fff' }}>,90</span>
              <span style={{ fontSize: '13px', color: '#999' }}>/mês</span>
            </div>
          </div>

          {/* 75 minutos inclusos */}
          <p
            style={{
              fontSize: '15px',
              color: '#10b981',
              fontWeight: 600,
              margin: 0,
            }}
          >
            75 minutos inclusos!
          </p>
        </div>

        {/* CTA Button */}
        <button
          onClick={() => {
            onComplete();
            window.location.href = '/register';
          }}
          style={{
            background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
            color: '#000',
            fontSize: '16px',
            fontWeight: 700,
            padding: '16px 0',
            borderRadius: '999px',
            border: 'none',
            cursor: 'pointer',
            width: '100%',
            maxWidth: '320px',
            marginBottom: '18px',
            letterSpacing: '0.3px',
          }}
        >
          Assine pelo App &rarr;
        </button>

        {/* Benefits list */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '12px',
            justifyContent: 'center',
            fontSize: '15px',
            fontWeight: 600,
            color: '#e5e5e5',
            marginBottom: '18px',
            maxWidth: '320px',
          }}
        >
          <span>✓ 75 min/mês</span>
          <span>✓ Todas máquinas</span>
          <span>✓ Economia</span>
          <span>✓ Cancele quando quiser</span>
        </div>

        {/* Payment info */}
        <p
          style={{
            fontSize: '12px',
            color: '#888',
            textAlign: 'center',
            marginBottom: '24px',
            maxWidth: '320px',
          }}
        >
          💳 Pagamento seguro com cartão • Renovação automática
        </p>

        {/* Footer branding */}
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '18px', fontWeight: 700, color: '#fff', margin: '0 0 2px 0' }}>
            AJB
          </p>
          <p style={{ fontSize: '12px', color: '#666', margin: 0 }}>
            Aluguel de Aspiradores Self-Service
          </p>
        </div>
      </div>
    </div>
  );
};
